module.exports = __webpack_public_path__ + "static/media/mzprofile.c7662a13.png";